import React, { Component } from "react";
import Card from "react-bootstrap/Card";
import PropTypes from "prop-types";
import { translate } from "react-switch-lang";
import Filter from "./Filter";
class ResourceTable extends React.Component {
  onClickCard = (location, isResource) => {
    var dataFromChild = {
      lat: location["Latitude"],
      lng: location["Longitude"],
    };
    if (isResource) {
      dataFromChild = {
        lat: location["Latitude"],
        lng: location["Longitude"],
      };
    } else {
      dataFromChild = {
        lat: location["Latitude"]["$numberDouble"],
        lng: location["Longitude"]["$numberDouble"],
      };
    }
    this.props.callbackFromParent(dataFromChild);
  };

  // Helper function to generate Google Maps URL
  getGoogleMapsUrl = (location, isResource) => {
    let lat, lng;
    if (isResource) {
      lat = location["Latitude"];
      lng = location["Longitude"];
    } else {
      lat = location["Latitude"]["$numberDouble"];
      lng = location["Longitude"]["$numberDouble"];
    }
    
    // Create Google Maps URL with coordinates
    return `https://www.google.com/maps?q=${lat},${lng}&ll=${lat},${lng}&z=15`;
  };

  // Helper function to share location
  shareLocation = (location, isResource) => {
    const { t } = this.props;
    
    // Get location details
    const name = isResource ? location[t("columns.Name")] : location[t("columns.ServiceName")];
    const address = location[t("columns.Address")];
    const telephone = isResource ? location[t("columns.Telephone")] : location[t("columns.ServiceTelephone")];
    const googleMapsUrl = this.getGoogleMapsUrl(location, isResource);
    
    // Create share text
    const shareText = `${name}\n📍 ${address}\n📞 ${telephone}\n🗺️ ${googleMapsUrl}`;
    
    // Check if Web Share API is supported
    if (navigator.share) {
      navigator.share({
        title: name,
        text: shareText,
        url: googleMapsUrl
      }).catch((error) => {
        console.log('Error sharing:', error);
        this.fallbackShare(shareText);
      });
    } else {
      // Fallback for browsers that don't support Web Share API
      this.fallbackShare(shareText);
    }
  };

  // Fallback share method
  fallbackShare = (shareText) => {
    // Copy to clipboard
    if (navigator.clipboard) {
      navigator.clipboard.writeText(shareText).then(() => {
        alert(this.props.t("share.CopiedToClipboard") || "Copied to clipboard!");
      }).catch(() => {
        this.legacyCopy(shareText);
      });
    } else {
      this.legacyCopy(shareText);
    }
  };

  // Legacy copy method
  legacyCopy = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      alert(this.props.t("share.CopiedToClipboard") || "Copied to clipboard!");
    } catch (err) {
      console.error('Failed to copy: ', err);
      alert(this.props.t("share.CopyFailed") || "Failed to copy. Please copy manually.");
    }
    document.body.removeChild(textArea);
  };

  render() {
    const { t } = this.props;
    const start = this.props.start;
    const isResource = this.props.isResource;
    const z = require("zebras");
    const locs = this.props.locations.sort((a, b) =>
      a.Category.localeCompare(b.Category)
    );
    const categories = z.unique(z.getCol(["Category"], locs));

    return (
      <div class="resourceTable">
        {/* <Filter both={true} md={false} lang="cn" /> */}
        {start ? (
          <Card bg="light" text="dark" style={{ "margin-top": 50 }}>
            <Card.Body>
              <Card.Title> Instructions </Card.Title>
              <Card.Text>{t("Help")}</Card.Text>
            </Card.Body>
          </Card>
        ) : (
          ""
        )}
        {locs.length < 1 ? (
          <div>
            <Card bg="light" text="dark" style={{ "margin-top": 10 }}>
              <Card.Body>{t("cards.NoResults")}</Card.Body>
            </Card>
          </div>
        ) : (
          <div>
            {locs.map((location) => {
              return (
                <div>
                  {isResource ? (
                    <Card
                      bg="light"
                      text="dark"
                      style={{ "margin-top": 10 }}
                      onClick={() => this.onClickCard(location, isResource)}
                    >
                      <Card.Body>
                        <Card.Title>
                          {t("columns.Category")}:{" "}
                          {t("categories." + location["Category"])}{" "}
                        </Card.Title>
                        <Card.Title>
                          {" "}
                          {location["index"]}. {location[t("columns.Name")]}{" "}
                        </Card.Title>
                        <Card.Text>
                          <b>{t("columns.Address")}:</b>{" "}
                          {location[t("columns.Address")]}
                          <br />
                          <b>{t("columns.Nature")}:</b>{" "}
                          {location[t("columns.Nature")]}
                          <br />
                          <b>{t("columns.Target")}:</b>{" "}
                          {location[t("columns.Target")]}
                          <br />
                          <b>
                            {location[t("columns.Hours")] !== null
                              ? t("columns.Hours") + ":"
                              : ""}{" "}
                          </b>
                          {location[t("columns.Hours")]} <br />
                          <b>{t("columns.Telephone")}:</b>{" "}
                          {location[t("columns.Telephone")]}
                          <br />
                          <b>{t("columns.Website")}: </b>{" "}
                          <a href={location[t("columns.Website")]}>
                            {" "}
                            {location[t("columns.Website")]}
                          </a>{" "}
                          <br />
                          <b>{t("columns.GoogleMaps") || "Google Maps"}: </b>{" "}
                          <a 
                            href={this.getGoogleMapsUrl(location, isResource)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {t("columns.ViewOnGoogleMaps") || "View on Google Maps"}
                          </a>{" "}
                          <br />
                          <button
                            className="btn btn-sm btn-outline-primary mt-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.shareLocation(location, isResource);
                            }}
                            style={{ fontSize: '0.8rem' }}
                          >
                            📤 {t("share.ShareLocation") || "Share Location"}
                          </button>
                          &nbsp;
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  ) : (
                    <Card
                      bg="light"
                      text="dark"
                      style={{ "margin-top": 10 }}
                      onClick={() => this.onClickCard(location)}
                    >
                      <Card.Body>
                        <Card.Title>
                          {" "}
                          {location["index"]["$numberInt"]}.{" "}
                          {location[t("columns.ServiceName")]}{" "}
                        </Card.Title>
                        <Card.Text>
                          <b>{t("columns.Address")}:</b>{" "}
                          {location[t("columns.Address")]}
                          <br />
                          <b>{t("columns.Category")}:</b>{" "}
                          {location[t("columns.Category")]}
                          <br />
                          <b>{t("columns.Facility")}:</b>{" "}
                          {location[t("columns.Facility")]}
                          <br />
                          <b>
                            {location[t("columns.Hours")] !== null
                              ? t("columns.Hours") + ":"
                              : ""}{" "}
                          </b>
                          {location[t("columns.Hours")]} <br />
                          <b>{t("columns.Telephone")}:</b>{" "}
                          {location[t("columns.ServiceTelephone")]} &nbsp;
                          <br />
                          <b>{t("columns.ServiceWebsite")}: </b>{" "}
                          <a
                            href={
                              location[t("columns.ServiceWebsite")] !== "N.A."
                                ? location[t("columns.ServiceWebsite")]
                                : "#"
                            }
                          >
                            {" "}
                            {location[t("columns.ServiceWebsite")]}
                          </a>{" "}
                          <br />
                          <b>📍 {t("columns.GoogleMaps") || "Google Maps"}: </b>{" "}
                          <a 
                            href={this.getGoogleMapsUrl(location, isResource)}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {t("columns.ViewOnGoogleMaps") || "View on Google Maps"}
                          </a>{" "}
                          <br />
                          <button
                            className="btn btn-sm btn-outline-primary mt-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.shareLocation(location, isResource);
                            }}
                            style={{ fontSize: '0.8rem' }}
                          >
                            📤 {t("share.ShareLocation") || "Share Location"}
                          </button>
                          &nbsp;
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

ResourceTable.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(ResourceTable);
